import { gql, useLazyQuery } from "@apollo/client";
import { Modal } from "antd";
import { useTranslation } from "react-i18next";

export const GET_BOOKING_LEVEL_WARNING = gql`
  query BookingLevelWarning($lessonId: ID, $levelId: ID) {
    bookingLevelWarning(lessonId: $lessonId, levelId: $levelId)
  }
`;

export default function useLevelBookingWarning() {
  const { t } = useTranslation("book_a_class");
  const [check, { loading }] = useLazyQuery(GET_BOOKING_LEVEL_WARNING, {
    fetchPolicy: "network-only",
  });
  const confirmLevel = async (variables: {
    lessonId?: number;
    levelId?: number;
  }) => {
    const result = await check({ variables });
    if (result.error) throw result.error;
    if (!result.data?.bookingLevelWarning) return true;
    return new Promise<boolean>((resolve) => {
      Modal.confirm({
        title: t("Review your class level"),
        content: t(
          "This class is above your current level and may be challenging for you and affect the learning experience of others. Would you still like to book?"
        ),
        okText: t("Book anyway"),
        cancelText: t("Cancel"),
        onOk: () => {
          resolve(true);
        },
        onCancel: () => {
          resolve(false);
        },
      });
    });
  };
  return { confirmLevel, checkingLevel: loading };
}
